import type { C1_Floor } from "../model/C1_Floor";
import type { C1_Opening } from "../model/C1_Opening";

/** Includes doors connecting the displayed rooms even when the neighboring room owns them. */
export function roomPlanOpenings(floor: C1_Floor, roomIds: ReadonlySet<string>): C1_Opening[] {
  const openings: C1_Opening[] = [];
  const seen = new Set<string>();
  for (const room of floor.rooms) {
    for (const opening of room.openings) {
      const belongsToRoom = roomIds.has(room.id);
      const connectsToRoom = opening.kind === "door" && roomIds.has(opening.partnerRoom?.id ?? "");
      if ((!belongsToRoom && !connectsToRoom) || seen.has(opening.id)) continue;
      seen.add(opening.id);
      openings.push(opening);
    }
  }
  return openings;
}
